import {Component, Input} from '@angular/core';
import {otherStates, topStates} from "../../../../util/states";
import {UntypedFormGroup} from "@angular/forms";

@Component({
  selector: 'app-state-select',
  templateUrl: './state-select.component.html',
  styleUrls: ['./state-select.component.scss']
})
export class StateSelectComponent {
  @Input() parentForm: UntypedFormGroup;
  @Input() formCtrlName: string;
  @Input() change;

  public readonly topStates = topStates;
  public readonly otherStates = otherStates;
}
